import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AIDatingServiceLandingPage from './pages/ai-dating-service-landing-page';
import CareersPage from './pages/careers-page';
import ContractOfferPage from './pages/contract-offer-page';
import PaymentPage from './pages/payment-page';
import FoundersMiniBookPage from './pages/founder-s-mini-book-page';
import RelationshipSearchWebinarPage from './pages/relationship-search-webinar-page';
import RelationshipImprovementWebinarPage from './pages/relationship-improvement-webinar-page';
import MissionCode11ResonanceSocietyPage from './pages/mission-code-11-resonance-society-page';
import { useGoogleAnalytics } from './hooks/useGoogleAnalytics';

/**
 * Google Analytics wrapper component
 * Initializes GA4 tracking for the entire application
 */
const AnalyticsWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useGoogleAnalytics();
  return <>{children}</>;
};

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <AnalyticsWrapper>
          <ScrollToTop />
          <RouterRoutes>
            <Route path="/" element={<AIDatingServiceLandingPage />} />
            <Route path="/payment-page" element={<PaymentPage />} />
            <Route path="/contract-offer-page" element={<ContractOfferPage />} />
            <Route path="/careers-page" element={<CareersPage />} />
            <Route path="/founder-s-mini-book-page" element={<FoundersMiniBookPage />} />
            <Route path="/relationship-search-webinar-page" element={<RelationshipSearchWebinarPage />} />
            <Route path="/relationship-improvement-webinar-page" element={<RelationshipImprovementWebinarPage />} />
            <Route path="/mission-code-11-resonance-society-page" element={<MissionCode11ResonanceSocietyPage />} />
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </AnalyticsWrapper>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default AppRoutes;